import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import FormBuilder from "../../../components/Components/FormBuilder/FormBuilder";
import "../css/questions.scss";
import "./postPayment.scss";
import { prepareDataFromDataLayerCoverage } from "../../../utils/prepareDataFromDataLayer";
import HttpLeadRepository from "../../../api/request/Lead/Lead.service";
import { GetLifeTrackerContext } from "../../../context/GetLifeTracker.context";
import FormButton from "../../../components/Components/FormBuilder/FormButtons";
import { I18nContext } from "../../../context/i18n.context";
import { FormBuilderProvider } from "../../../context/FormBuilder.context";
import { GlobalCountryApi } from "../../../utils/InternationlChanges";
import { DOMAIN } from "../../../constants/Global";
import {
  clauseRoute,
  isClauseModality,
} from "./components/BeneficiaryClause/beneficiaryClause";
import {
  trackQuestionAnswered,
  trackQuestionViewed,
  trackSubmissionError,
} from "../../../helpers/Tracking";

// Markets whose funnel can offer the pledge and exclusive clauses (AXA, AXA_WL).
const CLAUSE_DOMAINS = ["es", "wl_es"];

export default function PostPayment(props) {
  const { leadId, token, step, question, showButton, isLoading, setLoading } =
    props;

  const {
    state: { translate },
  } = useContext(I18nContext);

  const navigate = useNavigate();

  const { handleTrackerQuestion } = useContext(GetLifeTrackerContext);

  const [chat, setchat] = useState(false);

  const [answer, setAnswer] = useState(false);

  const [beneficiaries, setBeneficiaries] = useState(null);

  const [beneficiaryClausesAvailable, setBeneficiaryClausesAvailable] =
    useState(false);

  
  const [countryList, setCountryList] = useState([]);

  const leadRepository = new HttpLeadRepository(leadId, token);
  const isOneChoinceQuestion =
    question.type === "radio" &&
    question.componentName;

  const handleChat = () => setchat(!chat);

  const handleAnswer = (e) => {
    setAnswer(e);
  };

  const sendOnChange = (e) => {
    sendBeneficiaries(e);
  };

  const handleSubmit = () => {
    sendBeneficiaries(beneficiaries);
  };

  const sendBeneficiaries = async (beneficiariesTypes) => {
    // A clause is not a designation literal: its own screen writes it (and the
    // rows) through the designation endpoint.
    if (isClauseModality(beneficiariesTypes)) {
      trackQuestionAnswered(question.name, "postpayment");
      navigate(clauseRoute(beneficiariesTypes));
      return;
    }

    const data = {
      beneficiaries: beneficiariesTypes,
    };

      await leadRepository.saveData(data).then(() => {
        if (beneficiariesTypes) trackQuestionAnswered(question.name, "postpayment");
        if (beneficiariesTypes === "other") {
          navigate("/beneficiaries/1");
        } else if (beneficiariesTypes) {
          navigate("/coverage/7");
        }
      }).catch((error) => {
        trackSubmissionError(error);
        throw error;
      });
    
  };

  const handleBeneficiaries = (e) => {
    setBeneficiaries(e);
  };

  // Pregunta del postStack en pantalla (nacionalidad, dirección, beneficiarios, documento).
  useEffect(() => {
    if (question?.name) trackQuestionViewed(question.name, "postpayment");
  }, [question?.name]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (leadId && token) {
      leadRepository.getCheckoutData().then((data) => {
        if (data.code === 401) {
          navigate("/login");
        } else {
          setBeneficiaries(data.lead.beneficiaries);
          if (CLAUSE_DOMAINS.includes(DOMAIN)) {
            leadRepository
              .getBeneficiaryDesignation()
              .then(({ available, designation }) => {
                setBeneficiaryClausesAvailable(available);
                if (available && designation) {
                  setBeneficiaries(designation.modality);
                }
              })
              .catch(() => setBeneficiaryClausesAvailable(false));
          }
          const dataLayerCoverage = prepareDataFromDataLayerCoverage(
            data,
            leadId
          );
          handleTrackerQuestion({
            type: "GA",
            data: {
              ecommerce: dataLayerCoverage,
            },
          });
        }
      });
    }

    leadRepository.getQuestionNomenclator(GlobalCountryApi[DOMAIN]).then((res) => {
      const { answers } = res;

      setCountryList(answers);
    });
    
  }, [leadId, token]);

  const isIdCardType = question?.type === "idCard";

  return (
    <FormBuilderProvider
      answer={step === 1 ? answer : beneficiaries}
      question={question}
    >
      <div className="w-full questions-postPayment">
        <div className={"w-full questions-outerContainer"}>
          <div className={`questions-container ${isIdCardType ? 'questions-container-full-width' : ''}`}>
            <div className={`questions-innerContainer questions-innerContainer-it`}>
              <FormBuilder
                answer={step === 1 ? answer : beneficiaries}
                avatarStack={true}
                chat={chat}
                handleChange={handleChat}
                handleValues={step === 1 ? handleAnswer : handleBeneficiaries}
                isLoading={isLoading}
                leadId={leadId}
                question={question}
                sendOnChange={sendOnChange}
                handleSubmit={handleSubmit}
                token={token}
                setLoading={setLoading}
                countryList={countryList}
                beneficiaryClausesAvailable={beneficiaryClausesAvailable}
              />
            </div>
            {question.type === "radio" || question.type === "beneficiaries" && (
              <FormButton
                showButton={showButton()}
                isLoading={isLoading}
                isOneChoinceQuestion={isOneChoinceQuestion}
                componentName={question.componentName}
                translate={translate}
                handleSubmit={handleSubmit}
                question={question}
                answer={step === 1 ? answer : beneficiaries}
                questionStack={[]}
                isSticky={false}
              />
            )}
          </div>
        </div>

      </div>
    </FormBuilderProvider>
  );
}
